import React, { useState } from 'react';
import { Button } from './Button';
import { MoonIcon, BrainIcon, CalendarIcon, ArrowLeftIcon, PlayIcon, PauseIcon } from 'lucide-react';
interface SmartFeedProps {
  onBack?: () => void;
  onStartExercise?: (exerciseId: string) => void;
}
const SmartFeed: React.FC<SmartFeedProps> = ({
  onBack,
  onStartExercise
}) => {
  const [playingAudio, setPlayingAudio] = useState<string | null>(null);
  const handleCardClick = (id: string, type: string) => {
    if (type === 'audio') {
      setPlayingAudio(playingAudio === id ? null : id);
    } else if (type === 'exercise' && onStartExercise) {
      onStartExercise(id);
    } else {
      alert(`Deze ${type} wordt binnenkort beschikbaar gemaakt.`);
    }
  };
  return <div className="w-full max-w-xl mx-auto py-8" data-id="element-1184">
      <div className="flex items-center mb-8" data-id="element-1185">
        {onBack && <button onClick={onBack} className="mr-4 p-2 rounded-full hover:bg-gray-100" aria-label="Terug" data-id="element-1186">
            <ArrowLeftIcon className="w-5 h-5 text-gray-600" data-id="element-1187" />
          </button>}
        <h2 className="text-2xl font-light text-gray-800" data-id="element-1188">Voor jou</h2>
      </div>
      <div className="space-y-10" data-id="element-1189">
        <section data-id="element-1190">
          <h3 className="text-base font-medium text-gray-700 mb-4" data-id="element-1191">
            Gebaseerd op je slaappatroon
          </h3>
          <div className="overflow-x-auto pb-4" data-id="element-1192">
            <div className="flex space-x-5" style={{
            minWidth: 'max-content'
          }} data-id="element-1193">
              <div className="w-64 p-6 border-2 border-gray-300 rounded-xl hover:bg-gray-50 cursor-pointer" onClick={() => handleCardClick('sleep-tips', 'article')} data-id="element-1194">
                <h4 className="text-base font-medium text-gray-800 mb-4" data-id="element-1195">
                  Slaaptips
                </h4>
                <div className="flex items-center justify-center h-32 mb-3" data-id="element-1196">
                  <MoonIcon className="w-16 h-16 text-gray-700" data-id="element-1197" />
                </div>
                <p className="text-sm text-gray-600" data-id="element-1198">
                  Je hebt moeite met slaap – anderen vonden dit nuttig
                </p>
              </div>
              <div className="w-64 p-6 border-2 border-gray-300 rounded-xl hover:bg-gray-50 cursor-pointer" onClick={() => handleCardClick('evening-routine', 'exercise')} data-id="element-1199">
                <h4 className="text-base font-medium text-gray-800 mb-4" data-id="element-1200">
                  Avondritueel
                </h4>
                <div className="flex items-center justify-center h-32 mb-3" data-id="element-1201">
                  <MoonIcon className="w-16 h-16 text-gray-700" data-id="element-1202" />
                </div>
                <p className="text-sm text-gray-600" data-id="element-1203">
                  Ontspan voor het slapengaan met deze routine
                </p>
              </div>
              <div className="w-64 p-6 border-2 border-gray-300 rounded-xl hover:bg-gray-50 cursor-pointer" onClick={() => handleCardClick('sleep-cycle', 'article')} data-id="element-1204">
                <h4 className="text-base font-medium text-gray-800 mb-4" data-id="element-1205">
                  Slaapcyclus
                </h4>
                <div className="flex items-center justify-center h-32 mb-3" data-id="element-1206">
                  <MoonIcon className="w-16 h-16 text-gray-700" data-id="element-1207" />
                </div>
                <p className="text-sm text-gray-600" data-id="element-1208">
                  Begrijp je slaappatronen beter
                </p>
              </div>
            </div>
          </div>
        </section>
        <section data-id="element-1209">
          <h3 className="text-base font-medium text-gray-700 mb-4" data-id="element-1210">
            Maandag focus
          </h3>
          <div className="p-6 border-2 border-gray-300 rounded-xl hover:bg-gray-50 cursor-pointer" onClick={() => handleCardClick('monday-focus', 'exercise')} data-id="element-1211">
            <div className="flex items-start" data-id="element-1212">
              <div className="w-14 h-14 rounded-full border-2 border-gray-300 flex items-center justify-center mr-4" data-id="element-1213">
                <CalendarIcon className="w-7 h-7 text-gray-700" data-id="element-1214" />
              </div>
              <div data-id="element-1215">
                <h4 className="text-base font-medium text-gray-800 mb-2" data-id="element-1216">
                  Op maandag voel jij je vaak gejaagd – herkenbaar?
                </h4>
                <p className="text-sm text-gray-600" data-id="element-1217">
                  We hebben een korte oefening om je week rustiger te beginnen
                </p>
              </div>
            </div>
          </div>
        </section>
        <section data-id="element-1218">
          <h3 className="text-base font-medium text-gray-700 mb-4" data-id="element-1219">
            Favoriet van de week
          </h3>
          <div className="p-6 border-2 border-gray-300 rounded-xl hover:bg-gray-50 cursor-pointer" onClick={() => handleCardClick('mindful-focus', 'audio')} data-id="element-1220">
            <h4 className="text-base font-medium text-gray-800 mb-4" data-id="element-1221">
              Mindful Focus
            </h4>
            <div className="flex items-center justify-center h-32 mb-3" data-id="element-1222">
              <BrainIcon className="w-16 h-16 text-gray-700" data-id="element-1223" />
            </div>
            <p className="text-sm text-gray-600 mb-4" data-id="element-1224">
              Jouw best gewaardeerde soundscape voor concentratie
            </p>
            <div className="w-full h-3 bg-gray-200 rounded-full" data-id="element-1225">
              <div className="w-2/3 h-full bg-gray-500 rounded-full" data-id="element-1226"></div>
            </div>
            <div className="flex justify-between mt-1" data-id="element-1227">
              <span className="text-xs text-gray-500" data-id="element-1228">0:00</span>
              <span className="text-xs text-gray-500" data-id="element-1229">10:00</span>
            </div>
            <div className="mt-3 flex justify-center" data-id="element-1230">
              <button className="p-2 rounded-full bg-gray-200 hover:bg-gray-300" onClick={e => {
              e.stopPropagation();
              setPlayingAudio(playingAudio === 'mindful-focus' ? null : 'mindful-focus');
            }} data-id="element-1231">
                {playingAudio === 'mindful-focus' ? <PauseIcon className="w-5 h-5 text-gray-700" data-id="element-1232" /> : <PlayIcon className="w-5 h-5 text-gray-700" data-id="element-1233" />}
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default SmartFeed;